import $ from 'jquery'

$(document).on('turbolinks:load', function(){

  payacct_selected()

  var field_text = ""
  var field_type = ""
  console.log("toggle.js  file")

  $(".password_visible").bind( "click", function (event) {
    if ($(".password_visible_field")[0].type == 'password') {
      field_text = 'visibility_on'
      field_type = 'text'
      iconShowHide("bxs-hide", "bxs-show")
    }
    else {
      iconShowHide("bxs-show", "bxs-hide")
      field_type = 'password'
      field_text = 'visibility_off'
    }

    $(".password_visible_field").removeAttr("type").prop('type', field_type);
  });

  function iconShowHide(showIcon, hideIcon) {
    document.querySelector(".password_visible").classList.add(showIcon)
    document.querySelector(".password_visible").classList.remove(hideIcon)
  }

  // $( "#company_setting_payacct_type" ).bind( "click", function (event) {
  //   var payacct_type = $( "#company_setting_payacct_type" ).val()
  //   console.log("payacct_type ", payacct_type)
  //   if(payacct_type == "Account")
  //   {
  //     console.log("is account")
  //     $('#payacct-product').hide()
  //     $('#payacct-account').show()
  //   }
  //   else
  //   {
  //     console.log("is product")
  //     $('#payacct-account').hide()
  //     $('#payacct-product').show()
  //   }
  // });

})
